import React, { FC } from "react";
import { AppBar, AppBarProps } from "@mui/material"

const AppBarWrapper: FC<AppBarProps> = ({...props}) => <AppBar {...props}/>

export default AppBarWrapper;